import { setEqualHeights, tabletViewMax, openVideoInModal } from './util';

const AllInBenefitsDynamicBlock = (() => {

    function checkNumberTiles() {
        const cardListAll = document.querySelectorAll('.js-benefits-dynamic-card-list');

        cardListAll.forEach((cardList) => {
            if (cardList.childNodes.length === 2) {
                cardList.classList.add('card__list--two-items');

                if (window.innerWidth > tabletViewMax) {
                    setEqualHeights($('.js-all-in-bennefits-dynamic-item'), 2);
                }
            }

            if (cardList.childNodes.length === 4) {
                cardList.classList.add('card__list--four-items');

                if (window.innerWidth > tabletViewMax) {
                    setEqualHeights($('.js-all-in-bennefits-dynamic-item'), 4);
                }
            }
        });
    }

    function handleModalVideo() {
        if ($('.js-benefits-video-button').length) {
            $('.js-benefits-video-button').on('click', (e) => {
                e.preventDefault();
                const videoUrl = $(e.currentTarget).data('video');
                openVideoInModal(videoUrl);

                $('.tingle-modal').addClass('benefits-dynamic-modal');

                if ($('.benefits-dynamic-modal').length > 1) {
                    $('.benefits-dynamic-modal').hide();
                    $('.benefits-dynamic-modal:last-of-type').show();
                }
            });
        }
    }

    return {
        init() {
            if (window.innerWidth > tabletViewMax) {
                setEqualHeights($('.js-all-in-bennefits-dynamic-item'), 3);
            }
            checkNumberTiles();
            handleModalVideo();
        }
    };
})();

export default (() => {
    $(document).ready(AllInBenefitsDynamicBlock.init);
    $(window).on('scroll', AllInBenefitsDynamicBlock.scroll);
})();
